import Constants from 'src/actions/types';
import links_to_graph_data from 'src/utils/links_to_graph';

const initialState = {
  loading: false,
  message: null,
  severity: null,
  links: [],
  graph: null
};

const clusterReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.CLUSTER_RECORDLINKS_REQUEST: {
      const newState = {
        ...state,
        links: [],
        loading: true
      };

      return newState;
    }

    case Constants.CLUSTER_RECORDLINKS_SUCCESS: {
      const newState = {
        ...state,
        message: null,
        links: action.payload,
        graph: links_to_graph_data(action.payload),
        loading: false
      };

      return newState;
    }

    case Constants.CLUSTER_RECORDLINKS_FAILURE: {
      const newState = {
        ...state,
        loading: false
      };

      return newState;
    }

    case Constants.CLUSTER_CLASSIFY_SUCCESS: {
      const link = action.payload;
      // console.log(
      //   'Changed the classification of link ' +
      //     link.recordLinkId +
      //     ' to ' +
      //     link.state +
      //     ' graph is ' +
      //     JSON.stringify(state.graph)
      // );
      // We need to change in the graph the state of the edges
      // that was modified.
      const index = state.graph.edges.findIndex(
        edge => edge.data.id === link.recordLinkId
      );
      const newEdge = { ...state.graph.edges[index] };
      newEdge.data = { ...newEdge.data, state: link.state };
      const newGraph = {
        nodes: state.graph.nodes,
        edges: [
          ...state.graph.edges.slice(0, index),
          newEdge,
          ...state.graph.edges.slice(index + 1)
        ]
      };
      // We also need to change in the list of links
      // the state of the link that was modified.
      const linkIndex = state.links.findIndex(
        alink => alink.recordLinkId === link.recordLinkId
      );
      const newLinks = [
        ...state.links.slice(0, linkIndex),
        link,
        ...state.links.slice(linkIndex + 1)
      ];
      const newState = {
        ...state,
        loading: false,
        graph: newGraph,
        links: newLinks
      };

      return newState;
    }

    case Constants.CLUSTER_CLASSIFY_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.CLUSTER_DELETELINK_SUCCESS: {
      const link = action.payload;

      // We need to change in the graph and remove the edge
      // that was deleted
      const index = state.graph.edges.findIndex(
        edge => edge.data.id === link.recordLinkId
      );
      const newGraph = {
        nodes: state.graph.nodes,
        edges: [
          ...state.graph.edges.slice(0, index),
          ...state.graph.edges.slice(index + 1)
        ]
      };
      // We also need to change the list of links
      // and remove the link that was deleted
      const linkIndex = state.links.findIndex(
        alink => alink.recordLinkId === link.recordLinkId
      );
      const newLinks = [
        ...state.links.slice(0, linkIndex),
        ...state.links.slice(linkIndex + 1)
      ];
      const newState = {
        ...state,
        loading: false,
        graph: newGraph,
        links: newLinks
      };

      return newState;
    }

    case Constants.CLUSTER_CLEAR_ERRORS: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };
      return newState;
    }

    default: {
      return state;
    }
  }
};

export default clusterReducer;
